import { ActionsUnion, createAction } from 'spw-redux/types';
import { ISpaceType } from 'spw-redux/modules/space_types/types';

export const CREATE_CUSTOM_SPACE_TYPE = 'customSpaces/CREATE_CUSTOM_SPACE_TYPE';
export const CREATE_CUSTOM_SPACE_TYPE_CHILD =
  'customSpaces/CREATE_CUSTOM_SPACE_TYPE_CHILD';
export const CREATE_CUSTOM_ESA_SPACE_TYPE =
  'customSpaces/CREATE_CUSTOM_ESA_SPACE_TYPE';
export const UPDATE_CUSTOM_SPACE_TYPE = 'customSpaces/UPDATE_CUSTOM_SPACE_TYPE';
export const DELETE_CUSTOM_SPACE_TYPE = 'customSpaces/DELETE_CUSTOM_SPACE_TYPE';
export const SET_DIALOG_SPACE_TYPE_STATE =
  'customSpaces/SET_DIALOG_SPACE_STATE';
export const SET_CURRENT_PARENT = 'customSpaces/SET_CURRENT_PARENT';

const createCustomESASpaceType = ({
  spaceType,
  parentSpaceType,
  clientFacingName,
}: {
  spaceType: Partial<ISpaceType>;
  parentSpaceType?: Partial<ISpaceType>;
  clientFacingName?: string;
}) =>
  createAction(CREATE_CUSTOM_ESA_SPACE_TYPE, {
    spaceType,
    parentSpaceType,
    clientFacingName,
  });

const createCustomSpaceTypeChild = ({
  spaceTypeId,
  name,
  clientFacingName,
  unitsHigh,
  callback,
}: {
  spaceTypeId: number;
  name: string;
  clientFacingName?: string;
  unitsHigh: number | null;
  callback?: () => void;
}) =>
  createAction(CREATE_CUSTOM_SPACE_TYPE_CHILD, {
    spaceTypeId,
    name,
    clientFacingName,
    unitsHigh,
    callback,
  });

const createCustomSpaceType = ({
  spaceType,
  insertToWorksheet,
  clientFacingName,
  previousId,
  callback,
}: {
  spaceType: Partial<ISpaceType>;
  insertToWorksheet?: boolean;
  clientFacingName?: string;
  previousId: number | null;
  callback?: () => void;
}) =>
  createAction(CREATE_CUSTOM_SPACE_TYPE, {
    spaceType,
    insertToWorksheet,
    clientFacingName,
    previousId,
    callback,
  });

const updateCustomSpaceType = (
  spaceTypeId: number,
  spaceType: Partial<ISpaceType>,
  clientFacingName?: string
) =>
  createAction(UPDATE_CUSTOM_SPACE_TYPE, {
    spaceTypeId,
    spaceType,
    clientFacingName,
  });
const deleteCustomSpaceType = (spaceType: ISpaceType) =>
  createAction(DELETE_CUSTOM_SPACE_TYPE, { spaceType });
const setDialogSpaceState = (state: string) =>
  createAction(SET_DIALOG_SPACE_TYPE_STATE, { state });
const setCurrentParent = (parent: ISpaceType) =>
  createAction(SET_CURRENT_PARENT, { parent });

export const actions = {
  createCustomSpaceType,
  createCustomSpaceTypeChild,
  createCustomESASpaceType,
  updateCustomSpaceType,
  deleteCustomSpaceType,
  setDialogSpaceState,
  setCurrentParent,
};

export type Actions = ActionsUnion<typeof actions>;
